<div class="time">
  <rt-icon name="calendar-clock" size="medium" margin-right />
  <div>
    <span margin-bottom-small-xx>{{
      'app.mailbox.send_later_scheduled_for_date' | translate
    }}</span>
    <span>
      @switch (sendAtTiming) {
        @case ('today') {
          <strong text-yellow [rtTooltip]="localizedDate.full" [rtTooltipPosition]="'above'"
            >{{ 'app.common.today' | translate }} {{ localizedDate.simple }}
          </strong>
        }
        @case ('tomorrow') {
          <strong text-yellow [rtTooltip]="localizedDate.full" [rtTooltipPosition]="'above'"
            >{{ 'app.common.tomorrow' | translate }} {{ localizedDate.simple }}</strong
          >
        }
        @case ('after-tomorrow') {
          <strong>{{ localizedDate.full }}</strong>
        }
      }
    </span>
    @if (showTimezone) {
      <span text-light>{{ timezoneString }}</span>
    }
  </div>
</div>

<div class="actions">
  <rt-icon-button
    variant="tertiary"
    iconName="delete"
    shape="square"
    class="danger-on-hover"
    [rtTooltip]="'app.mailbox.send_later_delete' | translate"
    [rtTooltipPosition]="'above'"
    (click)="delete.emit()"
  />
  <rt-button variant="tertiary" (click)="edit.emit()">{{
    'app.common.edit' | translate
  }}</rt-button>
</div>
